/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Credit_Exhaustion_Accomplishments_TitleInputs */

const en_credit_exhaustion_accomplishments_title = /** @type {(inputs: Credit_Exhaustion_Accomplishments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Look what you've done this month:`)
};

const de_credit_exhaustion_accomplishments_title = /** @type {(inputs: Credit_Exhaustion_Accomplishments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Monat hast du erreicht:`)
};

const fr_credit_exhaustion_accomplishments_title = /** @type {(inputs: Credit_Exhaustion_Accomplishments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce mois-ci, tu as accompli :`)
};

const es_credit_exhaustion_accomplishments_title = /** @type {(inputs: Credit_Exhaustion_Accomplishments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este mes has logrado:`)
};

const it_credit_exhaustion_accomplishments_title = /** @type {(inputs: Credit_Exhaustion_Accomplishments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo mese hai realizzato:`)
};

const nl_credit_exhaustion_accomplishments_title = /** @type {(inputs: Credit_Exhaustion_Accomplishments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze maand heb je bereikt:`)
};

const pl_credit_exhaustion_accomplishments_title = /** @type {(inputs: Credit_Exhaustion_Accomplishments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W tym miesiącu udało Ci się:`)
};

const fi_credit_exhaustion_accomplishments_title = /** @type {(inputs: Credit_Exhaustion_Accomplishments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tässä kuussa olet saavuttanut:`)
};

const da_credit_exhaustion_accomplishments_title = /** @type {(inputs: Credit_Exhaustion_Accomplishments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne måned har du opnået:`)
};

const sv_credit_exhaustion_accomplishments_title = /** @type {(inputs: Credit_Exhaustion_Accomplishments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna månad har du åstadkommit:`)
};

/**
* | output |
* | --- |
* | "Look what you've done this month:" |
*
* @param {Credit_Exhaustion_Accomplishments_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const credit_exhaustion_accomplishments_title = /** @type {((inputs?: Credit_Exhaustion_Accomplishments_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credit_Exhaustion_Accomplishments_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_credit_exhaustion_accomplishments_title(inputs)
	if (locale === "fr") return fr_credit_exhaustion_accomplishments_title(inputs)
	if (locale === "es") return es_credit_exhaustion_accomplishments_title(inputs)
	if (locale === "it") return it_credit_exhaustion_accomplishments_title(inputs)
	if (locale === "nl") return nl_credit_exhaustion_accomplishments_title(inputs)
	if (locale === "pl") return pl_credit_exhaustion_accomplishments_title(inputs)
	if (locale === "fi") return fi_credit_exhaustion_accomplishments_title(inputs)
	if (locale === "da") return da_credit_exhaustion_accomplishments_title(inputs)
	if (locale === "sv") return sv_credit_exhaustion_accomplishments_title(inputs)
	return en_credit_exhaustion_accomplishments_title(inputs)
});